import request, { getRandomParam } from '../request';
// 【选项】获取货物产权公司选项
export function getCargoOwnerApi() {
    return request.post('/cargo/options/owner', getRandomParam());
}
// 【选项】获取货产权方式选项
export function getCargoOwnershipTypeApi() {
    return request.post('/cargo/options/ownership/type', getRandomParam());
}
// 【选项】获取货物包装方式选项
export function getPackingMethodApi() {
    return request.post('cargo/options/packing/method', getRandomParam());
}
// 【选项】获取货物计费单位选项
export function getUnitBillingApi() {
    return request.post('/cargo/options/unit/billing', getRandomParam());
}
// 【选项】获取货物货名选项
export function getCargoItemApi(param) {
    return request.post('/cargo/options/item', param);
}
// 【选项】获取货物租船条款选项
export function getTermChartingApi(param) {
    return request.post('/cargo/options/term/chartering', param);
}
// 【选项】获取货盘标记选项
export function getOrderTagApi() {
    return request.post('/cargo/options/order/tag', getRandomParam());
}
// 【选项】获取IMSBC选项
export function getImsbcApi() {
    return request.post('/cargo/options/imsbc', getRandomParam());
}
export function addCargoApi(cargo) {
    return request.post('/cargo/add', cargo);
}
// 【货物】收藏货物
export function copyCargoApi(id) {
    return request.post('/cargo/copy', { id });
}
// 【货物】获取企业下的货物
export function getCargoOwnedApi(classes) {
    return request.post('/cargo/owned', { class: classes });
}
// 【货物】搜索平台所存在的原始货物
export function cargoSearchApi(options) {
    return request.post('/cargo/search', options);
}
// 【货物】获取货物详情
export function getCargoDetailApi(id) {
    return request.post('/cargo/detail', { id });
}
// 【货物】获取货物最新操作日志
export function getCargoLogLatestApi(options) {
    return request.post('/cargo/log/latest', options);
}
// 【货物】获取指定货物的主权宣示历史
export function getCargoOwnershipHistoryApi(id) {
    return request.post('/cargo/history/application/ownership', { id });
}
// 【货物】获取当前月货盘编辑日志
export function getCargoOrderEditHistoryApi(id) {
    return request.post('/cargo/history/order/edit', { id });
}
// 【货物】将货物放入回收站
export function cargoTrashApiApi(id) {
    return request.post('/cargo/trash', { id });
}
// 【货物】恢复货物
export function cargoRecycleApi(id) {
    return request.post('/cargo/recycle', { id });
}
// 【货物】强制删除货物
export function cargoDeleteApi(id) {
    return request.post('/cargo/delete', { id });
}
// 主权宣示
export function cargoOwnershipApplyApi(options) {
    return request.post('/cargo/ownership/apply', options);
}
// 租船条款类型
export const CHARTING_TYPE = {
    1: 'FullTerms',
    2: 'SomeRequirementsforChartering',
    3: 'CargodescriptioninCharteringOrder',
    4: 'ProformaCP'
};
// 【条款】获取企业下的租船条款
export function cargoTermChartingOwnedApi(options) {
    return request.post('/cargo/term/chartering/owned', options);
}
// 【条款】搜索平台所存在的原始租船条款
export function cargoTermChartingSearchApi(options) {
    return request.post('/cargo/term/chartering/search', options);
}
// 【条款】获取租船条款详情
export function cargoTermChartingDetailApi(id) {
    return request.post('/cargo/term/chartering/detail', { id });
}
export function cargoTermChartingAddApi(options) {
    return request.post('/cargo/term/chartering/add', options);
}
// 【条款】收藏租船条款
export function cargoTermChartingCopyApi(id) {
    return request.post('/cargo/term/chartering/copy', { id });
}
// 【条款】将租船条款放入回收站
export function cargoTermChartingTrashApi(id) {
    return request.post('/cargo/term/chartering/trash', { id });
}
// 【条款】恢复租船条款
export function cargoTermChartingRecycleApi(id) {
    return request.post('/cargo/term/chartering/recycle', { id });
}
// 【条款】强制删除租船条款
export function cargoTermChartingDeleteApi(id) {
    return request.post('/cargo/term/chartering/delete', { id });
}
export function cargoOrderAddApi(cargoOrder) {
    return request.post('/cargo/order/add', cargoOrder);
}
// 【货盘】获取货盘列表
export function cargoOrderOwnedApi(classes) {
    return request.post('/cargo/order/owned', { class: classes });
}
// 获取海运相关地理数据
export function addressMarineSearch(para) {
    return request.post('/common/address/marine/search', para);
}
// 【货盘】发布货盘/重新发布货盘
export function cargoOrderPublishApi(para) {
    return request.post('/cargo/order/publish', para);
}
// 【货盘】获取货盘发布时的设置信息
export function cargoOrderInformationPublishApi(para) {
    return request.post('/cargo/order/information/published', para);
}
// 【货盘】获取子货盘信息
export function cargoOrderInformationSubApi(para) {
    return request.post('/cargo/order/information/sub', para);
}
// 【货盘】获取货盘所有信息
export function cargoOrderInformationAllApi(para) {
    return request.post('/cargo/order/information/all', para);
}
// 【货盘】获取与货盘匹配的最新船盘
export function cargoOrderMatchedLatestApi(id, chartererId) {
    return request.post('/cargo/order/matched/latest', { orderId: id, chartererId: chartererId });
}
// 【货盘】将货盘放入回收站
export function cargoOrderTrashApi(id) {
    return request.post('/cargo/order/trash', { id });
}
// 【货盘】恢复货盘
export function cargoOrderRecoverApi(id) {
    return request.post('/cargo/order/recover', { id });
}
// 【货盘】强制删除货盘
export function cargoOrderDeleteApi(id) {
    return request.post('/cargo/order/delete', { id });
}
// 【货盘】获取货盘发布时的设置信息
export function cargoOrderInfoPublishedApi(para) {
    return request.post('/cargo/order/information/published', para);
}
